import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Spin } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import LenteListElement from './LenteListElement';
import Flex from '../../../shared/components/basic/Flex';
import Box from '../../../shared/components/basic/Box';

export default function LentesList({
  lentes, graduaciones, setSelecccionLente, setSelecccionTratamientoLente, trabajaConColores, alturaFocalObligatoria, errorSeleccion,
  seleccionarColorIntensidad, miColor, gamaColor, pasillo, modo, indices, gamasColoresOpciones, modoNoPel, onNextPage, isLoading,
  loadingColoresLente, loadingDiametrosLente, setSelecccionDiametroLente, obtenerDatosLentesRequest, setAlturaFocal, loadingTratamientosLente,
}) {
  const lentesKeys = Object.keys(lentes);
  const handleClick = (e, lenteKey, isSelected = false) => {
    const tratamientoClickado = e !== null && ((Array.isArray(e.target.parentElement.className) && e.target.parentElement.className.includes('tratamiento')) || (Array.isArray(e.target.className) && !e.target.className.includes('tratamiento')));
    if (!tratamientoClickado) {
      if (/* ( modoNoPel || !trabajaConColores) &&  */ !isSelected) {
        obtenerDatosLentesRequest(lenteKey);
      } else {
        setSelecccionLente(lenteKey);
      }
    }
  };
  const handleClickEvent = (func, lenteKey, datoId, isSelected, selectBoth = false) => {
    if (selectBoth) {
      func(lenteKey, datoId);
      handleClick(null, lenteKey, isSelected);
    } else if (isSelected) {
      func(lenteKey, datoId, isSelected);
    } else {
      handleClick(null, lenteKey, isSelected);
    }
  };
  const drawColoracion = ((gamaColor && gamaColor.tipo_id !== 1) || (miColor !== undefined && miColor !== null && miColor.gamaColor !== 1)) || modoNoPel;
  /*
  //filtrar por indices en el front
  const filteredLentesKeys = lentesKeys.filter((lenteKey) => {
    const lente = lentes[lenteKey];
    if (!lente) return false;
    const coincideIndice = indices.find(e => e.id === lente.indiceId);
    const indiceMaestro = indices.find(e => e.id === -1);
    if (indiceMaestro.isSelected && (coincideIndice === null || coincideIndice === undefined)) {
      return true;
    }
    return coincideIndice !== null && coincideIndice !== undefined && coincideIndice.isSelected;
  });
   */
  const hasMore = modoNoPel && (lentesKeys.length > 0 ? !lentes[lentesKeys[lentesKeys.length - 1]]?.esUltimaPagina : true);
  return (
    <Flex flexDirection="column" width="100%">
      <InfiniteScroll
        next={() => onNextPage()}
        scrollableTarget="infinite-scroll-pel-div"
        hasMore={hasMore}
        loader={<Flex my="16px" justifyContent="center"><Spin /></Flex>}
        dataLength={lentesKeys.length}
        refreshFunction={() => {}}
        pullDownToRefresh
        pullDownToRefreshThreshold={2}
        pullDownToRefreshContent={null}
        releaseToRefreshContent={null}

      >
        {lentesKeys.map((lenteKey) => {
          const lente = lentes[lenteKey];

          lente.key = lenteKey;
          const { isSelected } = lente;
          const colorFondoLinea = isSelected ? '#E6F7FF' : 'white';
          return (
            <Box
              key={lenteKey}
              onClick={(e) => { handleClick(e, lenteKey, isSelected); }}
              style={{ background: colorFondoLinea }}
            >
              <Box px={16}>
                { !isSelected && <Divider style={{ marginTop: 1, marginBottom: 0 }} />}
                <LenteListElement
                  lente={lente}
                  errorSeleccion={errorSeleccion}
                  trabajaConColores={trabajaConColores}
                  miColor={miColor}
                  gamasColoresOpciones={gamasColoresOpciones}
                  selectedGamaColor={gamaColor}
                  pasillo={pasillo}
                  graduaciones={graduaciones}
                  drawColoracion={drawColoracion}
                  expanded={isSelected}
                  loadingColoresLente={loadingColoresLente}
                  loadingDiametrosLente={loadingDiametrosLente}
                  loadingTratamientosLente={loadingTratamientosLente}
                  alturaFocalObligatoria={alturaFocalObligatoria}
                  seleccionarColorIntensidad={(key, datoId) => handleClickEvent(seleccionarColorIntensidad, key, datoId, isSelected)}
                  setSelecccionTratamientoLente={(key, datoId) => handleClickEvent(setSelecccionTratamientoLente, key, datoId, isSelected, true)}
                  setSelecccionDiametroLente={(key, datoId) => handleClickEvent(setSelecccionDiametroLente, key, datoId, isSelected)}
                  onAlturaFocalChange={(key, datoId) => handleClickEvent(setAlturaFocal, key, datoId, isSelected)}
                  modoNoPel={modoNoPel}
                  modo={modo}
                />

              </Box>
            </Box>
          );
        })
      }
      </InfiniteScroll>
    </Flex>
  );
}

LentesList.propTypes = {
  lentes: PropTypes.shape({}).isRequired,
  modo: PropTypes.string.isRequired,
  trabajaConColores: PropTypes.bool,
  alturaFocalObligatoria: PropTypes.bool,
  modoNoPel: PropTypes.bool.isRequired,
  setSelecccionLente: PropTypes.func,
  setAlturaFocal: PropTypes.func,
  loadingDiametrosLente: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingColoresLente: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingTratamientosLente: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  obtenerDatosLentesRequest: PropTypes.func,
  setSelecccionDiametroLente: PropTypes.func,
  setSelecccionTratamientoLente: PropTypes.func,
  seleccionarColorIntensidad: PropTypes.func,
  miColor: PropTypes.shape({}),
  tratamientoSeleccionado: PropTypes.shape({}),
  gamasColoresOpciones: PropTypes.arrayOf(PropTypes.shape({})),
  gamaColor: PropTypes.shape({
    id: PropTypes.number,
    categoria_id: PropTypes.number,
    clasificacion_foco_id: PropTypes.number,
    gama_color: PropTypes.string,
    nombre: PropTypes.string,
    valor: PropTypes.number,
    empresa_id: PropTypes.number,
    tipo_id: PropTypes.number,
    activa: PropTypes.bool,
    oculta: PropTypes.bool,
    foto: PropTypes.string,
  }),
  pasillo: PropTypes.shape({
    id: PropTypes.number,
    isSelected: PropTypes.bool,
  }),
  indices: PropTypes.arrayOf(PropTypes.shape({ isSelected: PropTypes.bool })).isRequired,
};
LentesList.defaultProps = {
  setSelecccionLente: () => {},
  setAlturaFocal: () => {},
  setSelecccionTratamientoLente: () => {},
  seleccionarColorIntensidad: () => {},
  getColoresLenteRequest: () => {},
  obtenerDatosLentesRequest: () => {},
  setSelecccionDiametroLente: () => {},
  gamaColor: undefined,
  loadingColoresLente: { running: false, success: false },
  loadingDiametrosLente: { running: false, success: false },
  loadingTratamientosLente: { running: false, success: false },
  pasillo: { id: 0 },
  miColor: null,
  trabajaConColores: false,
  alturaFocalObligatoria: false,
  tratamientoSeleccionado: null,
  gamasColoresOpciones: [],
};
